module.exports = __webpack_public_path__ + "media/images/logo-light-612ca72581908d4c9361d8dd31303711.png";